<template>
<div>
<el-button type="info" plain size="mini" @click="centerDialogVisible = true">导入 <i class="el-icon-upload el-icon--right"></i></el-button>
 

<el-dialog 
  title="导入"
  :visible.sync="centerDialogVisible"
  :lock-scroll="false"
  :close-on-click-modal="false"
  :show-close="true"
  width="18%"
  
  :before-close="handleClose"
  left>

  <el-upload
  class="upload-demo"
  ref="upload"
  action="#"
   
  :auto-upload="false">
  <el-button slot="trigger" type="info" size="mini" @click="removelink">浏览 <i class="el-icon-search el-icon--right"></i></el-button>

  <el-button style="margin-left: 10px;" size="mini" type="info"  @click="upload">上传 <i class="el-icon-upload2 el-icon--right"></i></el-button>
  
  <div class="el-upload__tip" slot="tip">只支持xls/xlsx格式类型的文件 </div>
</el-upload>
  <span slot="footer" class="dialog-footer">
    <el-button type="info" @click="diposed" size="mini">取消</el-button>
  </span>
</el-dialog>

</div>
</template>

<script>
export default {
  name: "FileImporter",
  props: ['apiurl'],
  data() {
    return {
      centerDialogVisible: false
      
    };
  },
   methods: {        
          handleClose(done)
          {
            this.diposed();
            done();
          },
          upload()
          {
          
           var fileelements =document.getElementsByName('file');
           
           for(var i=0;i<fileelements.length;i++)
           {
              var links= document.getElementsByClassName('el-upload-list__item-name');   
            if(fileelements[i].files.length<1||links.length==0)
            {
              this.$message({
                message: "请选择上传文件！",
                type: "error",
                showClose: true,
                center: true
              });
             return ;
            }         
              var formData = new FormData();
             var file=fileelements[i].files[0];  
           
             var isexcel = JSON.stringify(file.name).split(".xls").length>1;
             if(!isexcel)
             {
               this.$message({
                message: "只支持xls/xlsx格式类型的文件",
                type: "error",
                showClose: true,
                center: true
              });
             return ;
             }
             formData.append("Files", file);
             
             this.$axios
            .post(this.apiurl, formData);  
             this.diposed();
           }
           
          },
          removelink()
          {
            document.getElementsByName('file')[0].value="";
             var links= document.getElementsByClassName('el-upload-list__item-name');   
             for(var i=0;i<links.length;i++)
             {
               links[i].style.display="none"
             }
              
            
          },
          diposed()
          {
             document.getElementsByName('file')[0].value="";
             var links= document.getElementsByClassName('el-upload-list__item-name');   
             for(var i=0;i<links.length;i++)
             {
               links[i].style.display="none"
             }
            this.centerDialogVisible = false;
          } 
           
          }
};
 
 
</script>


// WEBPACK FOOTER //
// src/components/shared/FileImporter.vue